export const CATALOG_TYPES = [
    { value: 'ink', label: 'Tintas e RAL' },
    { value: 'characteristic', label: 'Características' },
    { value: 'finish', label: 'Acabamentos' },
    { value: 'surfacePreparation', label: 'Preparações de superfície' },
    { value: 'cleaningMethod', label: 'Métodos de limpeza' },
];
export const CATALOG_VIEW_TYPES = [
    { value: 'ink', label: 'Tintas e RAL' },
    { value: 'thickness', label: 'Micragens' },
    { value: 'characteristic', label: 'Características' },
    { value: 'finish', label: 'Acabamentos' },
    { value: 'surfacePreparation', label: 'Preparações de superfície' },
    { value: 'cleaningMethod', label: 'Métodos de limpeza' },
];
